<template>
  <div class="d-flex flex-column w-full video-bottom h-full">
      <main class="contentDarkModeContainer flex-grow-1">
        <div id="video-container" class="video-container h-full">
          <div class="d-flex justify-content-between h-full">
            <div class="flex-grow-1">
              <div class="subtabs darkMode d-flex align-items-center">
                <div class="mdc-tab-bar main-tabs" role="tablist">
                  <div class="mdc-tab-scroller pdl-12">
                    <div class="mdc-tab-scroller__scroll-area">
                      <div class="mdc-tab-scroller__scroll-content">
                        <button class="mdc-tab min-w-auto mdc-tab--active" role="tab"
                                @click="tabChange('tab1')" @keypress="tabChange('tab1')">
                            <span class="mdc-tab__content">
                              <span class="mdc-tab__text-label font-m t-body7">{{ $t('3719') }}</span>
                            </span>
                          <span :class="currentTab === 'tab1' ? 'mdc-tab-indicator--active' : ''" class="mdc-tab-indicator ">
                              <span
                                  class="mdc-tab-indicator__content mdc-tab-indicator__content--underline"></span>
                            </span>
                          <span class="mdc-tab__ripple"></span>
                        </button>

                        <button v-if="isLearningObjectiveTab" class="mdc-tab min-w-auto" role="tab" @click="tabChange('tab2')" @keypress="tabChange('tab2')">
                            <span class="mdc-tab__content">
                              <span class="mdc-tab__text-label font-m t-body7">{{ $t('3720') }}</span>
                            </span>
                          <span :class="currentTab === 'tab2' ? 'mdc-tab-indicator--active' : ''" class="mdc-tab-indicator ">
                              <span
                                  class="mdc-tab-indicator__content mdc-tab-indicator__content--underline"></span>
                            </span>
                          <span class="mdc-tab__ripple"></span>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

          <div class="divider-white divider-subtabs"></div>

            <div v-show="currentTab === 'tab1'" class="t-body1 t-color-whiteHigh height-recalc d-flex flex-column">
              <component :is="setComponentName" :lessonData="lessonData" :lightModeActive="lightModeActive" :nextLesson="nextLesson" :fetchLectureList="fetchLectureList"></component>
            </div>

            <div v-show="currentTab === 'tab2'" class="t-body1 t-color-whiteHigh height-recalc d-flex flex-column">
              <div v-show="!!learnPurposes" class="mgt-32 pdl-32 pdr-32 t-body6 font-r t-color-whiteHigh">{{ learnPurposes }}</div>
              <slot></slot>
            </div>
            </div>
          </div>
        </div>
      </main>
    </div>
</template>

<script>
import {MDCRipple} from '@material/ripple';
import "@/css/computerScience.css";
import {fileMixin} from "@/mixins/file";

export default {
  name: "Description",

  props: ['lessonName', 'lessonData', 'componentName', 'learnPurposes', 'materialObj', 'nextLesson', 'lightModeActive', 'fetchLectureList'],

  data() {
    return {
      isWiki: false,
      currentTab: "tab1"
    }
  },

  mixins: [fileMixin],

  components: {
    'VIDEO': () => import('../VideoType'),
    'html-type': () => import('../HtmlType'),
    'INTERACTIVE_HTML': () => import('../InteractiveHtmlType'),
  },

  computed: {
    setComponentName() {
      return this.componentName
    },

    isLearningObjectiveTab() {
      return !!this.learnPurposes || this.materialObj && this.materialObj.length > 0;
    }
  },

  mounted() {
    this.setMaterialUi();
  },

  methods: {
    tabChange(currentTab) {
      this.currentTab = currentTab;
    },

    setMaterialUi() {
      const buttonRipple = [].map.call(document.querySelectorAll('.mdc-button, .mdc-list, .mdc-list-item, .mdc-card__primary-action, .mdc-chip-set'), function (el) {
        let button = new MDCRipple.attachTo(el);
        return button;
      })

      if (document.querySelector('.mdc-tab-bar')) {
        let tabBar = new mdc.tabBar.MDCTabBar(document.querySelector('.mdc-tab-bar'));
      }

      const settings = {
        fill: `var(--Saleline)`,
        background: 'rgba(255, 255, 255, 0.38)'
      };

      const sliders = document.querySelectorAll('.range-slider');
      Array.prototype.forEach.call(sliders, (slider) => {
        let sliderInput = slider.querySelector('input');
        if (sliderInput === null) {
          return;
        }
        sliderInput.addEventListener('input', (event) => {
          applyFill(event.target);
        });
        applyFill(slider.querySelector('input'));
      });

      function applyFill(slider) {
        const percentage = 100 * (slider.value - slider.min) / (slider.max - slider.min);
        const bg = `linear-gradient(90deg, ${settings.fill} ${percentage}%, ${settings.background} ${percentage + 0.1}%)`;
        slider.style.background = bg;
      }

    },
  }

}
</script>

<style scoped>
.height-recalc{
  height: calc(100vh - 164px);
}
</style>
